export default (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 8.25002C4.5 7.42159 5.17157 6.75002 6 6.75002H8.25C9.07843 6.75002 9.75 7.42159 9.75 8.25002V20.25C9.75 21.0784 9.07843 21.75 8.25 21.75H6C5.17157 21.75 4.5 21.0784 4.5 20.25V8.25002ZM8.25 8.25002H6V20.25H8.25V8.25002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 8.25002C14.25 7.42159 14.9216 6.75002 15.75 6.75002H18C18.8284 6.75002 19.5 7.42159 19.5 8.25002V20.25C19.5 21.0784 18.8284 21.75 18 21.75H15.75C14.9216 21.75 14.25 21.0784 14.25 20.25V8.25002ZM18 8.25002H15.75V20.25H18V8.25002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9.75002C18 9.3358 18.3358 9.00002 18.75 9.00002H21C21.3978 9.00002 21.7794 9.15805 22.0607 9.43936C22.342 9.72066 22.5 10.1022 22.5 10.5V18C22.5 18.3978 22.342 18.7794 22.0607 19.0607C21.7794 19.342 21.3978 19.5 21 19.5H18.75C18.3358 19.5 18 19.1642 18 18.75C18 18.3358 18.3358 18 18.75 18H21V10.5H18.75C18.3358 10.5 18 10.1642 18 9.75002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.93934 9.43936C2.22064 9.15805 2.60217 9.00002 3 9.00002H5.25C5.66421 9.00002 6 9.3358 6 9.75002C6 10.1642 5.66421 10.5 5.25 10.5H3V18H5.25C5.66421 18 6 18.3358 6 18.75C6 19.1642 5.66421 19.5 5.25 19.5H3C2.60218 19.5 2.22065 19.342 1.93934 19.0607C1.65803 18.7794 1.5 18.3978 1.5 18V10.5C1.5 10.1022 1.65804 9.72066 1.93934 9.43936Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25 14.25C8.25 13.8358 8.58579 13.5 9 13.5H15C15.4142 13.5 15.75 13.8358 15.75 14.25C15.75 14.6642 15.4142 15 15 15H9C8.58579 15 8.25 14.6642 8.25 14.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 14.25C21 13.8358 21.3358 13.5 21.75 13.5H23.25C23.6642 13.5 24 13.8358 24 14.25C24 14.6642 23.6642 15 23.25 15H21.75C21.3358 15 21 14.6642 21 14.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14.25C0 13.8358 0.335786 13.5 0.75 13.5H2.25C2.66421 13.5 3 13.8358 3 14.25C3 14.6642 2.66421 15 2.25 15H0.75C0.335786 15 0 14.6642 0 14.25Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.375 4.36255C9.375 3.94834 9.71079 3.61255 10.125 3.61255H13.875C14.2892 3.61255 14.625 3.94834 14.625 4.36255C14.625 4.77676 14.2892 5.11255 13.875 5.11255H10.125C9.71079 5.11255 9.375 4.77676 9.375 4.36255Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.73755C12.4142 1.73755 12.75 2.07334 12.75 2.48755V6.23755C12.75 6.65176 12.4142 6.98755 12 6.98755C11.5858 6.98755 11.25 6.65176 11.25 6.23755V2.48755C11.25 2.07334 11.5858 1.73755 12 1.73755Z"
      fill="currentColor"
    />
  </>
);
